import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_m96b98ugs5: FaireBrandEntity = {
  token: "b_m96b98ugs5",
  type: "brand",
  name: "California Naturals",
  avatarUrl:
    "https://cdn.faire.com/fastly/17a2b380a403e5a983a56ef2e6b9fb05806690101fdb1d1b78755ae25db2a4ac.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f7b7e5680d2174525750b7c7f29f840db26f197c21ac64dcde81598d9fdd34ce.webp",
  logoUrl:
    "https://cdn.faire.com/fastly/17a2b380a403e5a983a56ef2e6b9fb05806690101fdb1d1b78755ae25db2a4ac.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f7b7e5680d2174525750b7c7f29f840db26f197c21ac64dcde81598d9fdd34ce.webp",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 5,
  isTopShop: true,
  isInsider: true,
  description:
    "All the good stuff for your everyday. Naturally-derived, clean ingredients. Free from junk & kind to you.\n\nAt California Naturals, we’re on a mission to provide clean & naturally-derived hair & body products that deliver unreal results you can feel good about.\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:11.084Z",
    importedBy: "entity-db-cli",
  },
};
